import React, { forwardRef, useImperativeHandle, useRef } from "react";
import Lottie from "lottie-react";
import { SCORE_EMOJI_ANIMATION } from "../data/npsEmojiAnimations";
import "./NPSAnimatedEmoji.css";

// Plays the Lottie reaction for a score. Idle by default and plays once on
// hover/focus (call `.play()` via ref) - except `loop`, which autoplays
// continuously, matching the "average score" hero emoji in the design.
const NPSAnimatedEmoji = forwardRef(({ score, size = 20, loop = false }, ref) => {
  const lottieRef = useRef(null);

  useImperativeHandle(ref, () => ({
    play: () => lottieRef.current?.goToAndPlay(0, true),
    reset: () => lottieRef.current?.goToAndStop(0, true),
  }), []);

  return (
    <span className="nps-animated-emoji" style={{ width: size, height: size }} aria-hidden="true">
      <Lottie
        lottieRef={lottieRef}
        animationData={SCORE_EMOJI_ANIMATION[score]}
        loop={loop}
        autoplay={loop}
        onDOMLoaded={() => { if (!loop) lottieRef.current?.goToAndStop(0, true); }}
      />
    </span>
  );
});

export default NPSAnimatedEmoji;
